import styles from './index.module.scss'
import React, { useEffect } from 'react'
import Image from 'next/image'
import { insuranceInfoLogoItems } from './constants'

const InsuranceInfo: React.FC = () => {
  useEffect(() => {
    /*
      Added clone logo slider track div element so that we have smooth
      and continuous logo sliding animation effect
    */
    const logoSliderElement = document.querySelector(
      `.${styles.InsuranceInfo__insuranceLogoSlider}`
    )
    const logoSliderTrackElement = document.querySelector(
      `.${styles.InsuranceInfo__insuranceLogoSlider__track}`
    )

    const cloneLogoSliderTrackElement = logoSliderTrackElement.cloneNode(true)
    logoSliderElement.appendChild(cloneLogoSliderTrackElement)
  }, [])

  return (
    <div className={styles.InsuranceInfo}>
      <h2 className={styles.InsuranceInfo__headingText}>
        We accept most major insurances, covering over 190 million Americans.
      </h2>
      <div className={styles.InsuranceInfo__headingInfo}>
        <Image
          src="/icons/insurance-shield-with-plus.svg"
          alt="Insurance info logo"
          width={70}
          height={62}
          unoptimized
        />
        <div className={styles.InsuranceInfo__insurancePlanText}>
          575+ insurance plans accepted
        </div>
      </div>
      <div className={styles.InsuranceInfo__contentBanner}>
        <div className={styles.InsuranceInfo__insuranceLogoSliderContainer}>
          <div className={styles.InsuranceInfo__logoSliderGradientLeft} />
          <div className={styles.InsuranceInfo__logoSliderGradientRight} />
          <div className={styles.InsuranceInfo__insuranceLogoSlider}>
            <div className={styles.InsuranceInfo__insuranceLogoSlider__track}>
              {insuranceInfoLogoItems.map(({ src, alt, width }, index) => (
                <img src={src} alt={alt} width={width} key={index} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InsuranceInfo
